import * as React from 'react';
import {
    InfoBarMessageViewState,
    InfoBarMessageRank,
    InfoBarMessageSource,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import CustomMailtip, { CustomMailtipRecipientInfo } from '../components/CustomMailtip';
import getOOFMessage from './getOOFMessage';
import MailTipDetails from '../store/schema/MailTipDetails';

/**
 * returns InfoBarMessageViewState for recipients for which custom mailtip is set.
 * returns null if there are no recipient with custom mailtip set.
 */
const getCustomMessageViewState = (
    customMessageInfos: MailTipDetails[]
): InfoBarMessageViewState => {
    if (!customMessageInfos.length) {
        return null;
    }

    const recipientsInfo: CustomMailtipRecipientInfo[] = customMessageInfos.map(
        customMessageInfo => ({
            recipient: customMessageInfo.recipient,
            customMessage: getOOFMessage(customMessageInfo.message),
        })
    );

    return {
        key: 'Custom',
        message: customMessageInfos.map(messageInfo => messageInfo.message).join(' '),
        messageElement: <CustomMailtip recipientsInfo={recipientsInfo} />,
        rank: InfoBarMessageRank.Info,
        source: InfoBarMessageSource.Compose,
    };
};

export default getCustomMessageViewState;
